export default __webpack_public_path__ + "static/media/logo-asana.19cd44a7.svg";